module.exports = __webpack_public_path__ + "34736292/img/grid-web-icon.d0395d64.svg";